import { useI18n } from 'vue-i18n';

/**
 * Splits the string at the first instance of one of given words.
 * @param value String to split.
 * @param splitAtWords Words to split at.
 */
export function splitAtWord(value?: string | null, words: string[] = ['via', 'mot']): string[] {
    if (!value) return [];
    return value.split(new RegExp(`(\\b(?:${words.join('|')})\\b.*)`, 'i'), 2).map(x => x.trim());
}

/**
 * Splits a headsign string into title and subtitle parts.
 * @param value Headsign string to split.
 * @returns Object containing title and optional subtitle.
 */
export function splitHeadsign(value?: string | null) {
    const [title, subtitle] = splitAtWord(value);
    return {
        title: title || '',
        subtitle
    };
}

export function useUnitsOfMeasure() {
    const { t } = useI18n();

    const unitsOfMeasure = {
        minutes: t('common.resources.minutes', 'min'),
        hours: t('common.resources.hours', 'h')
    };

    return {
        unitsOfMeasure
    };
}
